import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=9e7343ae&scoped=true"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"
import style0 from "./mainPage.vue?vue&type=style&index=0&id=9e7343ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7343ae",
  null
  
)

export default component.exports